import React from 'react';
import NavBar from './homepagecomponent/NavBar';
import Footer from './homepagecomponent/Footer';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-background font-sans text-neutral-900">
      <NavBar />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
